import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PostOrganizationFormFields {

    public name: FormField
    public identifier: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          true,
        )
        this.identifier = new FormField(
          'identifier',
          'Identifier',
          null,
          FormFieldType.text,
          true,
        )

    }
}

const fields = new PostOrganizationFormFields()

export const postOrganizationFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  identifier: fields.identifier,
};